module.exports = "/images/responsive.svg?710110014dea3b222e9fd1e4c6dd2dc1";